import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["startDate", "endDate", "searchInput", "form"]

  setDateRange(event) {
    const days = parseInt(event.params.days, 10)
    const end = new Date()
    const start = new Date()
    if (days > 0) start.setDate(start.getDate() - days)
    this.startDateTarget.value = start.toISOString().split("T")[0]
    this.endDateTarget.value = end.toISOString().split("T")[0]
  }

  resetFilters() {
    window.location.href = window.location.pathname
  }

  clearSearch() {
    this.searchInputTarget.value = ""
    this.formTarget.submit()
  }

  changePerPage(event) {
    const url = new URL(window.location.href)
    url.searchParams.set("per_page", event.target.value)
    url.searchParams.delete("page")
    window.location.href = url.toString()
  }
}
